import { APP_INITIALIZER, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard, T4coreModule, UIService } from 't4core';
import { T4CommonModule } from '../../t4common/t4common';
import { ServiceModule } from '../Service/service.module';
import { BookingOverviewComponent } from './components/bookingOverview/bookingOverview';
import { FindBookingDialog } from './dialogs/findBookingDialog/findBookingDialog';
import { BookingsComponent } from './views/bookings/bookings.component';
import { CustomersComponent } from './views/customers/customers.component';
import { HomeComponent } from './views/home/home.component';
import { InvoiceComponent } from './views/Invoice/Invoice';
import { LocationKPIComponent } from './views/LocationKPI/LocationKPI';
import { LogisticsComponent } from './views/Logistics/Logistics.component';
import { MapComponent } from './views/map/map.component';
import { ServiceComponent } from './views/Service/Service';
import { CountingComponent } from './views/Counting/Counting';
import { CountingDetailsComponent } from './views/CountingDetails/CountingDetails';
import { CountingDialog } from './dialogs/CountingDialog/CountingDialog';
import { FuturePickupsComponent } from './views/FuturePickups/FuturePickups.component'
import { FutureReturnsComponent } from './views/FutureReturns/FutureReturns.component'
import { HistoricalPickupComponent } from './views/HistoricalPickups/HistoricalPickups';
import { HistoricalReturnComponent } from './views/HistoricalReturns/HistoricalReturns';
import { TireChangeDialog } from './dialogs/TireChangeDialog/TireChangeDialog';





@NgModule({
    declarations: [
        HomeComponent,
        MapComponent,
        LogisticsComponent,
        ServiceComponent,
        BookingOverviewComponent,
        InvoiceComponent,
        FindBookingDialog,
        LocationKPIComponent,
        BookingsComponent,
        CustomersComponent,
        CountingComponent,
        CountingDetailsComponent,
        CountingDialog,
        FuturePickupsComponent,
        FutureReturnsComponent,
        HistoricalPickupComponent,
        HistoricalReturnComponent,
        TireChangeDialog,
    ],
    imports: [
        T4CommonModule,
        ServiceModule,
        T4coreModule,
        RouterModule.forChild([
            {
                path: 'OneWay',
                canActivate: [AuthGuard],
                data: { index: 10, title: "OneWay", roles: ['OneWayAdmin', 'GroupManager', 'LocationManager', 'Clerk'], requireOneWay: true, icon: 'keyboard_tab', color: 'accent1' },
                children: [
                    { path: '', redirectTo: 'Dashboard', pathMatch: 'full' },
                    {
                        path: "Dashboard",
                        canActivate: [AuthGuard],
                        component: HomeComponent,
                        data: { title: "Dashboard", requireOneWay: true, toolTip: "Dashboard", roles: ['OneWayAdmin', 'GroupManager', 'LocationManager'], icon: 'bar_chart', color: 'accent1' }
                    },
                    {
                        path: "Bookings",
                        canActivate: [AuthGuard],
                        component: BookingsComponent,
                        data: { title: "Bookings", requireOneWay: true, toolTip: "Bookings", roles: ['Clerk', 'LocationManager'], icon: 'today', color: 'accent1' }
                    },
                    {
                        path: "Map",
                        canActivate: [AuthGuard],
                        component: MapComponent,
                        data: { title: "Map", requireOneWay: true, toolTip: "Map", roles: ['OneWayAdmin'], icon: 'map', color: 'accent1' }
                    },
                    //{
                    //    path: "Service",
                    //    canActivate: [AuthGuard],
                    //    component: ServiceComponent,
                    //    data: { title: "Service", requireOneWay: true, roles: ['OneWayAdmin'], icon: 'warning', color: 'accent1' }
                    //},
                    //{
                    //    path: "Logistics",
                    //    canActivate: [AuthGuard],
                    //    component: LogisticsComponent,
                    //    data: { title: "Logistics", requireOneWay: true, toolTip: "Logistics", roles: ['OneWayAdmin', 'Logistics'], icon: 'local_shipping', color: 'accent1' }
                    //},
                    {
                        path: "LocationKPI",
                        canActivate: [AuthGuard],
                        component: LocationKPIComponent,
                        data: { title: "Location KPI", requireOneWay: true, toolTip: "Invoices", roles: ['OneWayAdmin', 'GroupManager'], icon: 'payment', color: 'accent1' }
                    },
                    {
                        path: "Invoices",
                        canActivate: [AuthGuard],
                        component: InvoiceComponent,
                        data: { title: "Invoices", requireOneWay: true, toolTip: "Invoices", roles: ['GroupManager', 'LocationManager'], icon: 'payment', color: 'accent1' }
                    },
                    {
                        path: "CustomerList",
                        canActivate: [AuthGuard],
                        component: CustomersComponent,
                        data: { title: "Customer list", requireOneWay: true, toolTip: "Customer list", roles: ['OneWayAdmin'], icon: 'person', color: 'accent1' }
                    },
                    {
                        path: "Counting",
                        canActivate: [AuthGuard],
                        component: CountingComponent,
                        data: { title: "Counting", requireOneWay: true, toolTip: "OneWay Countings", roles: ['OneWayAdmin'], icon: 'rule' }
                    },
                    {
                        path: "Counting/:Id",
                        canActivate: [AuthGuard],
                        component: CountingDetailsComponent,
                        data: { hidden: true, title: "Counting", requireOneWay: true, toolTip: "OneWay Countings", roles: ['OneWayAdmin'] }
                    },
                    {
                        path: "Reports",
                        canActivate: [AuthGuard],
                        data: { title: "Reports", icon: 'assignment', roles: ['Clerk', 'LocationManager'], requireOneWay: true, toolTip: "Reports", color: 'accent1' },
                        children: [
                          { path: '', redirectTo: 'FuturePickups', pathMatch: 'full' },
                          {
                            path: "FuturePickups",
                            canActivate: [AuthGuard],
                            component: FuturePickupsComponent,
                            data: { title: "Future Pickups", icon: 'call_made', roles: ['Clerk', 'LocationManager']}
                          },
                          {
                            path: "FutureReturns",
                            canActivate: [AuthGuard],
                            component: FutureReturnsComponent,
                            data: { title: "Future Returns", icon: 'call_received', roles: ['Clerk', 'LocationManager']}
                          }
                          ,
                          {
                            path: "HistoricalPickups",
                            canActivate: [AuthGuard],
                            component: HistoricalPickupComponent,
                            data: { title: "Historical pickups", icon: 'call_made', roles: ['Clerk', 'LocationManager'] }
                          }
                          ,
                          {
                            path: "HistoricalReturns",
                            canActivate: [AuthGuard],
                            component: HistoricalReturnComponent,
                            data: { title: "Historical returns", icon: 'call_received', roles: ['Clerk', 'LocationManager'] }
                          }
                        ]
                    },
                ]
            },
        ])
    ],
    providers: [T4CommonModule, { provide: APP_INITIALIZER, useFactory: initModule, deps: [UIService], multi: true }],
    exports: [BookingOverviewComponent]
})
export class OneWayAdmin { }


// Module initialization
export function initModule(settings: UIService) {
  return () => {
    settings.applySettings({
      dialogs: [
        { key: "T4.OneWay.FindBooking", dialog: FindBookingDialog },
        { key: "T4.OneWay.CountingDialog", dialog: CountingDialog },
        { key: "T4.OneWay.TireChangeDialog", dialog: TireChangeDialog },
      ]
    });
  };
}
// Module initialization
